/**
 * The live parent/staff portal (a separate app). Linked from the header so
 * families and staff can reach it straight from the website.
 */
export const PORTAL_LOGIN_URL = "https://portal.childsplaymucklagh.ie/login";
